import { State } from '../store/reducer';
import { AppName } from '../models/app';

export function selectAppName(state: State): AppName | undefined {
    return state.app.name;
}
export function selectPathname(state: State): string | undefined {
    return state.app.pathname;
}